module.exports = __webpack_public_path__ + "img/a2.51f5fae3.png";